module.exports = {"name":"Vyhľadávanie klubov","icon":"<i class='material-icons'>brightness_auto</i>","widget":[{"type":"club-search","head":["Názov","Mesto","Adresa"],"cols":[["baseData.name.v"],["clubAdress.city"],["clubAdress.street","p.clubAdress.houseNumber"]],"initData":{}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/club-search/club-search.json
// module id = 315
// module chunks = 0